<template>
    <div class="relative overflow-hidden py-2">
        <SectionWrapper borderPosition="between" type="full" id="account">
            <template #title>
                <div class="flex flex-row justify-between items-center gap-8">
                    <div class="flex flex-row justify-between w-full items-center">
                        <strong v-if="title" class="relative">
                            {{ title }}
                        </strong>
                        <router-link v-if="link && link_title" class="text-blue text-xs" :to="link">{{ link_title }}</router-link>
                    </div>
                    <div class="flex-row justify-end gap-4 hidden lg:flex">
                        <div :class="'slider-button-prev-' + $.uid" class="text-black cursor-pointer">
                            <Icon type="TailLeft" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                        </div>
                        <div :class="'slider-button-next-' + $.uid" class="text-black cursor-pointer">
                            <Icon type="TailRight" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                        </div>
                    </div>
                </div>
            </template>

            <template #content>
                <div v-if="data?.length" :class="'slider-' + $.uid">
                    <div class="swiper-wrapper">
                        <component :is="component" v-for="item in data" :key="item.id" :data="item" class="swiper-slide" />
                    </div>
                </div>
                <p v-else>
                    {{ $t('No Data') }}
                </p>
            </template>
        </SectionWrapper>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export default {
    mounted() {
        this.init();
    },

    updated() {
        this.init();
    },

    props: ['component', 'data', 'title', 'link', 'link_title'],

    methods: {
        init() {
            if (this.data?.length) {
                new Swiper('.slider-' + this.$.uid, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: {
                        prevEl: '.slider-button-prev-' + this.$.uid,
                        nextEl: '.slider-button-next-' + this.$.uid
                    },
                    width: 290
                });
            }
        }
    }
};
</script>
